/*
 * collection-sale-toggle.js — Peak Design–style "Sale" toggle for the collection filter bar.
 * Shopify can't natively filter "on sale", so this is a client-side switch: when ON, cards
 * without a sale badge (.bst-card__sale) are hidden via a grid class + :has() CSS. State is
 * kept in a module variable (survives Horizon's facet re-renders) and mirrored to ?sale=1.
 */
(function () {
  'use strict';

  // Popisky přicházejí lokalizované z main-collection.liquid (window.ryzCollectionL10n),
  // aby anglická stránka neukazovala česká slova. Fallback = původní CS texty.
  var L10N = window.ryzCollectionL10n || {};
  var SALE_LABEL = L10N.sale || 'Sleva';
  var SALE_ARIA = L10N.saleAria || 'Zobrazit jen produkty ve slevě';
  var SORT_LABEL = L10N.sort || 'Třídit';

  var saleOn = new URLSearchParams(location.search).get('sale') === '1';

  function reflectUrl() {
    var p = new URLSearchParams(location.search);
    if (saleOn) p.set('sale', '1'); else p.delete('sale');
    var q = p.toString();
    try { history.replaceState(null, '', location.pathname + (q ? '?' + q : '')); } catch (e) {}
  }

  function build() {
    var bar = document.querySelector('.facets--horizontal .facets__filters-wrapper');
    var grid = document.querySelector('.product-grid');
    if (!bar || !grid) return;

    // (re)inject the toggle if the facet bar was re-rendered
    var wrap = bar.querySelector('.sale-toggle');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'sale-toggle';
      wrap.innerHTML =
        '<span class="sale-toggle__label"></span>' +
        '<button type="button" role="switch" class="sale-toggle__switch"><span class="sale-toggle__knob"></span></button>';
      wrap.querySelector('.sale-toggle__label').textContent = bar.getAttribute('data-sale-label') || SALE_LABEL;
      wrap.querySelector('.sale-toggle__switch').setAttribute('aria-label', SALE_ARIA);
      wrap.querySelector('.sale-toggle__switch').addEventListener('click', function () {
        saleOn = !saleOn;
        reflectUrl();
        apply(grid, wrap);
      });
      bar.appendChild(wrap);
    }
    apply(grid, wrap);
    fixSort();
  }

  // Rename the sort label (localized) and reveal the selected value (Horizon hides it on
  // desktop via a `desktop:hidden` class). Re-runs on every rebuild so it survives facet
  // re-renders and reflects the current sort value.
  function fixSort() {
    var label = document.querySelector('.facets--horizontal [id^="sort-label"]');
    if (!label) return;
    if (label.textContent.trim() !== SORT_LABEL) label.textContent = SORT_LABEL;
    var status = label.parentElement && label.parentElement.querySelector('.facets__status');
    if (status && status.classList.contains('desktop:hidden')) {
      status.classList.remove('desktop:hidden');
      status.classList.add('sort-value-shown');
    }
  }

  function apply(grid, wrap) {
    grid.classList.toggle('is-sale-only', saleOn);
    wrap.classList.toggle('is-on', saleOn);
    var sw = wrap.querySelector('.sale-toggle__switch');
    if (sw) sw.setAttribute('aria-checked', saleOn ? 'true' : 'false');
  }

  function boot() {
    build();
    // Horizon re-renders the results list on filter/sort changes — re-inject + re-apply.
    var container = document.querySelector('.product-grid-container') || document.body;
    var mo = new MutationObserver(function () { build(); });
    mo.observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  setTimeout(build, 900);
})();
